import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: false,
})
export class FileSizePipe implements PipeTransform {
  transform(value: any, showRawValue: boolean = false): string {
    let isInteger = Number.isInteger(value);
    if (!isInteger) return value ?? '-';

    let size = +value;
    const originalSize = +value;

    if (size <= 0) return value;

    if (size < 1024) return this.format(`${size}`, 'B', originalSize, false);

    size = size / 1024;
    if (size < 1024)
      return this.format(
        `${Math.round(size)}`,
        'KB',
        originalSize,
        showRawValue,
      );

    size = size / 1024;
    return this.format(`${Math.round(size)}`, 'MB', originalSize, showRawValue);
  }

  private format(
    returnValue: string,
    returnSymbol: string,
    originalSize: number,
    showRawValue: boolean,
  ): string {
    if (showRawValue)
      return `${Number.parseFloat(returnValue).toLocaleString('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })} ${returnSymbol} (${originalSize.toLocaleString('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })} B)`;

    return returnValue + ' ' + returnSymbol;
  }
}
